"use strict";

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.array.index-of");

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var common_1 = __importDefault(require("../common"));

var Account = function Account(_a) {
  var rest = __rest(_a, []);

  return react_1["default"].createElement(common_1["default"], Object.assign({
    "data-icon": "help",
    viewBox: "0 0 20 20"
  }, rest), react_1["default"].createElement("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, react_1["default"].createElement("g", {
    transform: "translate(-25.000000, -226.000000)",
    fill: "currentColor"
  }, react_1["default"].createElement("g", {
    transform: "translate(14.000000, 123.000000)"
  }, react_1["default"].createElement("path", {
    d: "M21,103 C26.5228475,103 31,107.477153 31,113 C31,118.522847 26.5228475,123 21,123 C15.4771525,123 11,118.522847 11,113 C11,107.477153 15.4771525,103 21,103 Z M21,105 C16.581722,105 13,108.581722 13,113 C13,117.418278 16.581722,121 21,121 C25.418278,121 29,117.418278 29,113 C29,108.581722 25.418278,105 21,105 Z M20.696,115.802 C21.0226683,115.802 21.3026655,115.918666 21.536,116.152 C21.7693345,116.385335 21.886,116.665332 21.886,116.992 C21.886,117.318668 21.7693345,117.598666 21.536,117.832 C21.3026655,118.065335 21.0226683,118.182 20.696,118.182 C20.3693317,118.182 20.0893345,118.065335 19.856,117.832 C19.6226655,117.598666 19.506,117.318668 19.506,116.992 C19.506,116.665332 19.6226655,116.385335 19.856,116.152 C20.0893345,115.918666 20.3693317,115.802 20.696,115.802 Z M20.878,108.004 C21.7273376,108.004 22.4623302,108.248998 23.083,108.739 C23.7036698,109.229002 24.014,109.903329 24.014,110.762 C24.014,111.154002 23.9323341,111.517998 23.769,111.854 C23.6056658,112.190002 23.4096678,112.476999 23.181,112.715 C23.0285548,112.873667 22.8761111,113.026111 22.7236669,113.172333 L22.495,113.387 C22.2663322,113.597001 22.0703341,113.813999 21.907,114.038 C21.7436658,114.262001 21.662,114.485999 21.662,114.71 L19.73,114.71 C19.73,114.299331 19.8536654,113.907335 20.101,113.534 C20.2988677,113.235332 20.5101728,112.98296 20.7349196,112.77688 L20.906,112.631 C21.1953348,112.402332 21.4636654,112.134002 21.711,111.826 C21.9583346,111.517998 22.082,111.210002 22.082,110.902 C22.082,110.575332 21.9700011,110.323334 21.746,110.146 C21.5219989,109.968666 21.2093353,109.88 20.808,109.88 C20.0239961,109.88 19.4686683,110.295329 19.142,111.126 L17.49,110.174 C17.7700014,109.48333 18.2156636,108.949002 18.827,108.571 C19.4383364,108.192998 20.1219962,108.004 20.878,108.004 Z"
  })))));
};

exports["default"] = Account;